var assumptions = 
{
    estate_duty_exemption: 3500000,
    primary_residence_exemption: 2000000,
    small_business_exemption: 1800000,
    inclusion_rate_for_cgt: 40,
    masters_fees: 7000,
    transfer_costs: 2,
    vat_on_executors_fees: 15,
    estateDutyLT: 20, //Estate duty < 30M rand
    estateDutyGT: 25, //Estate duty > 30M rand
    cgtExclusionAtDeath: 300000
  }

  export default assumptions


// WEBPACK FOOTER //
// ./src/views/Fna/steps/objects/assumptions.js